export const isEmptyStr = (str: string) => {
  return !str || str?.length === 0;
};
